<template>
  <Graph
    :competitors="competitors"
    :container="container"
    :series="series"
    :categories="categories"
    :days="days"
    :filters="filters"
    :translationKeys="getTranslationKeys"
    :currency="currency"
    @select-day="onSelectDay"
  />
</template>
<script setup>
import { computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

const emit = defineEmits(['select-day'])

function onSelectDay(timestamp) {
  emit('select-day', timestamp)
}

import Graph from './Graph.vue'
import appAnalytics from '@/utils/tracking'

const { t } = useI18n()
const props = defineProps({
  container: {
    type: String,
    default: 'rate-insights-qraph',
  },
  isWaitingMode: {
    type: Boolean,
    default: false,
  },
  accommodationId: {
    type: Number,
    default: 0,
  },
  series: {
    type: Array,
    default() {
      return []
    },
  },
  currency: {
    type: String,
    default: '',
  },
  categories: {
    type: Object,
    default() {
      return {}
    },
  },
  days: {
    type: Object,
    default() {
      return {}
    },
  },
  competitors: {
    type: Object,
    default() {
      return {}
    },
  },
  filters: {
    type: Object,
    default() {
      return {}
    },
  },
})

const getTranslationKeys = computed(() => {
  return {
    averageRate: t('rate_insights_avg_rates'),
    room_type_double: t('room_type_double'),
    room_type_single: t(`room_type_single`),
    room_type_multi: t('room_type_FAM'),
    incl_breakfast: t('incl_breakfast'),
    excl_breakfast: t('excl_breakfast'),
  }
})

onMounted(() => {
  if (props.isWaitingMode) {
    appAnalytics.track(appAnalytics.events.RI_NO_BOOKING_SITES, {
      accommodationId: props.accommodationId,
    })
  }
})
</script>
